<template>
  <div style="padding: 30px 0">
    <div class="main-right">
      <div class="main-right-header">认证管理</div>
      <div class="bd_y"></div>
      <div class="content-item">
        <div class="item-header">
          <h3><i class="iconfont iconapiwendang_jianjie"></i>企业信息</h3>
          <div class="audit-status">
            <div class="status"><i class="iconfont" :class="{ iconshenhezhuangtai_weishenqingshibai: auditStatus === ''|| auditStatus === 3, iconshenhezhuangtai_shenhezhong: auditStatus === 0|| auditStatus === 1, iconshenhezhuangtai_tongguo: auditStatus === 2}"></i>审核状态：<span>{{auditStatus | statusFilter}}</span></div>
            <div class="reason" v-if="auditStatus === 3">失败原因：<span :title="failReason">{{failReason}}</span></div>
          </div>
        </div>
        <el-form ref="controlForm" :rules="rules" label-width="180px" :model="controlForm">
          <el-form-item label="企业全称：" prop="enterpriseName">
            <el-input
              v-model="controlForm.enterpriseName"
              maxlength="50"
              placeholder="请输入企业全称(限制4~50字符)" :disabled="isEditDisabled"></el-input>
          </el-form-item>
          <el-form-item
            label="企业地址："
            class="address"
            required
          >
          <el-col :span='7'><el-form-item prop="receiveAddress">
            <BaseAddress
              ref="receiverProvinceSearch"
              :initAddressData="receiverAddressData"
              :showLevel="3"
              v-model="controlForm.receiveAddress" :disabled="isEditDisabled">
            </BaseAddress>
            </el-form-item></el-col>
          <el-col :span='7' >
            <el-form-item prop="userDetailedAddress" class="nth-2">
                <el-input
                class="input"
                maxlength="50"
                v-model="controlForm.userDetailedAddress"
                placeholder="请输入企业详细地址(限制50字符)" :disabled="isEditDisabled"></el-input>
            </el-form-item>
          </el-col>
          </el-form-item>
          <el-form-item label="企业类型：" prop="enterpriseType">
            <el-select
              v-model="controlForm.enterpriseType"
              placeholder="请选择" :disabled="isEditDisabled">
              <el-option
                v-for="item in enterpriseTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left; color: #2b2b2b;">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="社会统一信用代码：" prop="socialCreditCode">
            <el-input
              placeholder="请输入社会统一信用代码"
              maxlength="18"
              v-model="controlForm.socialCreditCode" :disabled="isEditDisabled"></el-input>
          </el-form-item>
          <el-form-item
            label="营业执照："
            prop="businessLicensePath"
            class="address"
          >
            <div class="upload">
              <el-upload
                accept="image/jpeg,image/jpg,image/png"
                class="avatar-uploader"
                :headers="header"
                :action="actionUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :disabled="isEditDisabled">
                <img
                  v-if="businessLicenseImageUrl"
                  :src="businessLicenseImageUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span class="text" v-if="!businessLicenseImageUrl">上传营业执照</span>
            </div>
            <div class="upload-dec">支持所有图片格式，文件大小不超过5M <i class="iconfont iconicotishi" @mouseover="mouseoverBusiness"
            @mouseleave="mouseleaveBusiness">示例</i></div>
            <div class="example-business" v-show="isShow">
              <div class="img-box">
                <img src="../../../assets/images/home/business2.png" alt="示例图片">
              </div>
              <div class="explain">
                <p>1.请上传三证合一证清晰彩色扫描件或数码照片</p>
                <p>2.证件请在有效期内，且年检通过</p>
                <p>3.印章必须齐全（当年成立的可无年检章)</p>
                <p>4.证件需要是由中国大陆工商局或者市场监督管理局颁发</p>
                <p>5.支持jpeg、png、jpg格式</p>
              </div>
            </div>
          </el-form-item>
          <h3 style="margin-top:51px">
            <i class="iconfont iconkongzhitai_farenxinxi"></i>法人信息
          </h3>
          <el-form-item label="法人姓名：" prop="corporationName">
            <el-input
              placeholder="请输入法人姓名"
              maxlength="10"
              v-model="controlForm.corporationName" :disabled="isEditDisabled"></el-input>
          </el-form-item>
          <el-form-item label="证件类型：" prop="certificateType">
            <el-select
              v-model="controlForm.certificateType"
              placeholder="请选择" :disabled="isEditDisabled">
              <el-option
                v-for="item in cardTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" prop="corporationCardId">
            <el-input
              placeholder="请输入证件号码"
              v-model="controlForm.corporationCardId"
              maxlength="18"
              :disabled="isEditDisabled"></el-input>
          </el-form-item>
          <el-form-item label="户籍地址：" class="address" required>
            <el-col :span='7'>
              <el-form-item prop="corporationArea">
                <BaseAddress
                  ref="receiverProvinceSearch"
                  :initAddressData="receiverAddressData2"
                  :showLevel="3"
                  v-model="controlForm.corporationArea"
                  :disabled="isEditDisabled">
                </BaseAddress>
              </el-form-item>
            </el-col>
            <el-col :span='7' >
            <el-form-item prop="corporationDetailedAddress"  class="nth-2">
              <el-input
                class="input"
                v-model="controlForm.corporationDetailedAddress"
                maxlength="50"
                placeholder="请输入详细地址"
                :disabled="isEditDisabled"></el-input>
            </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="证件照片：" class="address" prop="corporationPhotoPath">
            <div class="upload">
              <el-upload
                class="avatar-uploader"
                accept="image/jpeg,image/jpg,image/png"
                :headers="header"
                :action="actionUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload"
                :disabled="isEditDisabled">
                <img v-if="idCardImageUrl" :src="idCardImageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span class="text" v-if="!idCardImageUrl">上传证件正面</span>
            </div>
            <div class="upload" style="margin-left:20px">
              <el-upload
                class="avatar-uploader"
                accept="image/jpeg,image/jpg,image/png"
                :headers="header"
                :action="actionUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess3"
                :before-upload="beforeAvatarUpload"
                :disabled="isEditDisabled">
                <img
                  v-if="idCardBackImageUrl"
                  :src="idCardBackImageUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span class="text" v-if="!idCardBackImageUrl">上传证件背面</span>
            </div>
            <div class="upload-dec">支持所有图片格式，文件大小不超过5M <i class="iconfont iconicotishi" @mouseover="mouseoverId"
            @mouseleave="mouseleaveId">示例</i></div>
            <div :class="{'example-id': auditStatus !== 2, 'example-id2': auditStatus === 2}" v-show="isShow2">
              <div class="img-box">
                <img src="../../../assets/images/home/idCard2.png" alt="示例图片">
                <img src="../../../assets/images/home/idCardBack2.png" alt="示例图片">
              </div>
              <div class="explain">
                <p>1.请上传身份证带有头像面的照片 </p>
                <p>2.请上传身份证带有国徽的照片 </p>
                <p>3.请确保证件两面完整，图像清晰、字体清晰，证件号码清晰可见</p>
                <p>4.支持jpeg、png、jpg格式</p>
              </div>
            </div>
          </el-form-item>
          <h3 style="margin-top:50px">
            <i class="iconfont iconkongzhitai_kaifazherenzheng"></i>开发者信息
          </h3>
          <el-form-item label="开发者姓名" prop="userName">
            <el-input
              v-model="controlForm.userName"
              maxlength="10"
              placeholder="请输入开发者姓名(限制10字符)"
              :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="userEmail">
            <el-input
              v-model="controlForm.userEmail"
              placeholder="请输入邮箱地址"
              :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="userPhone">
            <el-input
              v-model="controlForm.userPhone"
              maxlength="11"
              placeholder="请输入开发者手机号码"
              :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item label="短信验证码" prop="captcha" class="captchaItem">
            <el-input
              v-model="controlForm.captcha"
              maxlength="10"
              placeholder="请输入验证码"
              :disabled="isEdit"></el-input>
            <button
              class="commonBtn sendCode"
              @click.prevent="sendCodeBefore"
              :disabled="isCaptch"
            >
              <span v-if="!isSendCode">发送验证码</span>
              <span v-else>{{ time }}秒</span>
            </button>
          </el-form-item>
        </el-form>
        <button class="commonBtn nextStep" @click.prevent="nextStep" v-if="!auditStatus">提交审核</button>
        <button class="commonBtn nextStep" @click.prevent="isEdit = false" v-if="auditStatus && isEdit">修改</button>
        <div v-if="auditStatus && !isEdit">
          <button class="commonBtn back" @click.prevent="backBtn">返回</button>
          <button class="commonBtn save" @click.prevent="nextStep">保存</button>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="descriptionDialogVisible" :close-on-click-modal="false">
      <p>1）、证件必须为本公司所有，证件的相关信息可在当地工商局查询，企业名称及相关证件号须与填写内容一致；</p>
      <p>2）、企业营业执照须为清晰的加盖公章，且证件须在有效期内；</p>
      <p>3）、企业类型对号入座，不得随意选填；</p>
      <p>4）、证件照片须清晰有效。</p>
      <p>5）、应用类型须根据当前实际情况填写，可分为网站、移动应用及其他</p>
      <span slot="footer">
        <el-button type="primary" size="small" @click="descriptionDialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { RULES } from '@/constants/rules'
import { UPLOADUMG } from '@/api'
import BaseAddress from '@/components/BaseAddress'
import { RESPONSE_SUCCESS } from '@/constants'
export default {
  name: 'Authentication',
  components: { BaseAddress },
  data() {
    return {
      actionUrl: UPLOADUMG,
      businessLicenseImageUrl: '', //营业执照照片
      idCardImageUrl: '', //证件正面照片
      idCardBackImageUrl: '', //证件正面照片
      cardList: [], //证件照片列表 0 为 正面 1为反面
      auditStatus: '', // 审核状态 1：审核中   2：审核成功  3：审核失败
      failReason: '', // 失败原因
      receiverAddressData: {
        //企业地址
        formProps: {
          provinceIdProp: 'userProvinceId',
          provinceNameProp: 'userProvinceName',
          cityIdProp: 'userCityId',
          cityNameProp: 'userCityName',
          areaIdProp: 'userAreaId',
          areaNameProp: 'userAreaName',
        },
        defaultData: {}
      },
      receiverAddressData2: {
        //户籍地址
        formProps: {
          provinceIdProp: 'corporationProvinceId',
          provinceNameProp: 'corporationProvinceName',
          cityIdProp: 'corporationCityId',
          cityNameProp: 'corporationCityName',
          areaIdProp: 'corporationAreaId',
          areaNameProp: 'corporationAreaName',
        },
        defaultData: {}
      },
      controlForm: {
        receiveAddress: {},
        corporationArea: {}
      },
      rules: {
        enterpriseName: [
          {
            required: true,
            message: '请输入合法的公司名称',
            trigger: ['blur', 'change'],
          },
          {
            required: true,
            min: 4,
            max: 50,
            message: '请输入合法的公司名称(4~50字符)',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        enterpriseType: [
          {
            required: true,
            message: '请选择企业类型',
            trigger: ['blur', 'change'],
          },
        ],
        certificateType: [
          {
            required: true,
            message: '请选择证件类型',
            trigger: ['blur', 'change'],
          },
        ],
        userName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        corporationName: [
          {
            required: true,
            message: '请输入法人姓名',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        corporationCardId: [
          {
            required: true,
            message: '请输入证件号码',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        businessLicensePath: [
          {
            required: true,
            message: '请上传营业执照',
            trigger: ['blur', 'change'],
          },
        ],
        socialCreditCode: [
          {
            required: true,
            message: '请输入社会信用代码',
            trigger: ['blur', 'change'],
          },
          {
            required: true,
            max: 18,
            message: '请输入合法的社会信用代码',
            trigger: ['blur', 'change'],
          },
          RULES.noBlankSpace
        ],
        userEmail: [
          {
            required: true,
            message: '请输入正确的邮箱账号',
            trigger: ['blur', 'change'],
          },
          RULES.email
        ],
         userDetailedAddress:[
          { required: true, message: '请输入详细地址', trigger: ['blur', 'change']  },
          RULES.noBlankSpace
         ],
        corporationDetailedAddress: [
          {
            required: true,
            validator: this.receiveAddress,
            trigger: ['blur', 'change'],
          },
        ],
        corporationPhotoPath: [
          {
            required: true,
            validator: this.validateCardPath,
            trigger: 'blur',
          },
        ],
        userPhone: [RULES.phone, RULES.checkPhone],
        captcha: [RULES.phoneCode, RULES.noBlankSpace],
      },
      enterpriseTypeOptions: [
        {
          value: 1,
          label: '物流服务平台',
          desc: '为消费者提供一系列物流服务'
        },
        {
          value: 2,
          label: '软件供应商',
          desc: '为企业提供专业软件的独立开发商'
        },
        {
          value: 3,
          label: '商家自研',
          desc: '具有开发能力的电商卖家'
        },
        {
          value: 5,
          label: '电商平台',
          desc: 'B2B/B2C电子商务平台'
        },
        {
          value: 6,
          label: '快递柜/驿站',
          desc: '为消费者提供社区生活服务、快递寄存'
        },
        {
          value: 4,
          label: '其他'
        }
      ],
      cardTypeList: [
        { label: '居民身份证', value: 1 },
        { label: '护照', value: 2 },
        { label: '港澳居民通行证', value: 3 },
        { label: '台湾居民通行证', value: 4 }
      ],
      isShow: false, // 商业执照示例
      isShow2: false, // 身份证示例
      captcha: "", //腾讯验证码
      codeTimer: null,
      time: 60,
      isSendCode: false,
      isEdit: false,
      isSave: false,
      descriptionDialogVisible: false
    }
  },
  computed: {
    ...mapGetters(['user', 'token', 'uuid']),
    header() {
      return {
        authToken: this.token,
      }
    },
    isCaptch() {
      if (!this.auditStatus) {
        return this.isSendCode
      } else {
        if (this.isEdit) return true
        else return this.isSendCode
      }
    },
    isEditDisabled() {
      if (this.auditStatus === 2) {
        return true
      } else if(!this.auditStatus) {
        return false
      } else {
        if (this.isEdit) return true
        else return false
      }
    }
  },
  filters: {
    statusFilter(val){
      const myMap = new Map([
          [1,'审核中'],
          [2,'认证通过'],
          [3,'认证不通过']
        ])
      return  myMap.get(val) ? myMap.get(val) : '未申请'
    }
  },
  created() {
    if (this.token) {
      //判断是否认证
      this.isAuth()
    } else {
      this.$router.push({ path: '/register' })
    }
    this.initTencentCaptcha();
  },
  methods: {
    ...mapActions(['SET_UUID']),
    /**
     * @description 提交审核
     */
    async nextStep() {
      try {
        this.isSave = true
        const valie = await this.$refs['controlForm'].validate()
        if (!valie) return
        console.log('controlForm =>', this.controlForm)
        let newParams = {
          enterpriseName: this.controlForm.enterpriseName,
          enterpriseType: this.controlForm.enterpriseType,
          userProvinceId: this.controlForm.receiveAddress.userProvinceId,
          userProvinceName: this.controlForm.receiveAddress.userProvinceName,
          userCityId: this.controlForm.receiveAddress.userCityId,
          userCityName: this.controlForm.receiveAddress.userCityName,
          userAreaId: this.controlForm.receiveAddress.userAreaId,
          userAreaName: this.controlForm.receiveAddress.userAreaName,
          userDetailedAddress: this.controlForm.userDetailedAddress,
          socialCreditCode: this.controlForm.socialCreditCode,
          businessLicensePath: this.controlForm.businessLicensePath,
          corporationName: this.controlForm.corporationName,
          certificateType: this.controlForm.certificateType,
          corporationCardId: this.controlForm.corporationCardId,
          corporationProvinceId: this.controlForm.corporationArea
            .corporationProvinceId,
          corporationProvinceName: this.controlForm.corporationArea
            .corporationProvinceName,
          corporationCityId: this.controlForm.corporationArea
            .corporationCityId,
          corporationCityName: this.controlForm.corporationArea
            .corporationCityName,
          corporationAreaId: this.controlForm.corporationArea
            .corporationAreaId,
          corporationAreaName: this.controlForm.corporationArea
            .corporationAreaName,
          corporationDetailedAddress: this.controlForm
            .corporationDetailedAddress,
          corporationPhotoPath: this.cardList.join(','),
          userName: this.controlForm.userName,
          userPhone: this.controlForm.userPhone,
          userEmail: this.controlForm.userEmail,
          captcha: this.controlForm.captcha,
          userId: this.user.id
        }
        const res = await this.$API.platformCerCommit(newParams)
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success('提交成功')
          this.isAuth()
        } else {
          this.$message.error(res.msg)
        }
        this.isSave = false
      } catch (err) {
        console.log('error =>', err)
        this.isSave = false
      }
    },
    sendCodeBefore(){
      if (!this.controlForm.userPhone) {
          return this.$message.warning('请输入手机号')
      }
      this.captcha.show()
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = new window.TencentCaptcha('2033367267', this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        // 调用登陆
        this.sendCode(customParams)
        
        return res
      }
      // 验证不成功
      return null
    },
    /**
     * @description 发送验证码
     */
    sendCode({ticket,randstr}) {
      let httpParams = {
        phone: this.controlForm.userPhone,
        type: 'dev_cer',
        ticket,
        randstr
      }
      this.$API.sendMessage(httpParams).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.isSendCode = true
          clearInterval(this.codeTimer)
          this.codeTimer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              this.isSendCode = false
              this.time = 60
            }
          }, 1000)
          this.$message.success('获取手机验证码成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * @description 上传前
     */
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
       this.$message.error('请上传后缀为.jpeg|.png|.jpg的图片文件');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
        return false;
      }
      return isJPG && isLt2M;
    },
    async getImgUrl(path, imgName) {
      const res = await this.$API.getImgUrl({ path })
      if (res.code === RESPONSE_SUCCESS) {
        this[imgName] = res.data[0] || ''
      } else {
        this.$message.error(res.msg)
      }
    },
    backBtn() {
      this.isEdit = true
      this.isAuth()
    },
     /**
     * @description 营业执照上传成功回调
     */
    async handleAvatarSuccess(res) {
      this.controlForm.businessLicensePath = res.data
      await this.getImgUrl(res.data, 'businessLicenseImageUrl')
      this.$refs.controlForm.validateField('businessLicensePath')
    },
    /**
     * @description 身份证正面上传成功回调
     */
    async handleAvatarSuccess2(res) {
      this.cardList[0] = res.data
      await this.getImgUrl(res.data, 'idCardImageUrl')
      this.$refs.controlForm.validateField('corporationPhotoPath')
    },
    /**
     * @description 身份证反面上传成功回调
     */
    async handleAvatarSuccess3(res) {
      this.cardList[1] = res.data
      await this.getImgUrl(res.data, 'idCardBackImageUrl')
      this.$refs.controlForm.validateField('corporationPhotoPath')
    },
    /**
     * @description 判断是否认证
     */
    isAuth() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
          if(res.data.auditStatus == 2 && this.uuid.length == 0) {
            this.SET_UUID(res.data.uuid)
          }
          if (res.data.auditStatus !== 2 && res.data.auditStatus !== 1) {
            this.descriptionDialogVisible = true
          }
          if (res.data) {
            this.dataEcho(res.data)
          }
        } else {
          this.$message.error(res.msg)
        }
        this.$nextTick(() => {
          this.$refs.controlForm.clearValidate()
        })
      })
    },
    /**
     * @description 数据回显
     */
    dataEcho(val) {
      if (val.auditStatus) {
        this.isEdit = true
        const { auditStatus, userCompany, userDev } = val
        const { userProvinceId, userProvinceName, userCityId, userCityName, userAreaId, userAreaName } = userDev
        const { corporationProvinceId, corporationProvinceName, corporationCityId, corporationCityName, corporationAreaId, corporationAreaName } = userCompany
        this.auditStatus = auditStatus
        this.failReason = userCompany.remark
        this.controlForm = {
          enterpriseName: userDev.enterpriseName, // 公司名字
          certificateType: userCompany.certificateType,
          corporationCardId: userCompany.corporationCardId,
          userProvinceId: userProvinceId, // 省份
          userProvinceName: userProvinceName, // 省份
          userCityId: userCityId,
          userCityName: userCityName, // 城市
          userAreaId: userAreaId,
          userAreaName: userAreaName,
          enterpriseType: userDev.enterpriseType, // 公司类型
          userDetailedAddress: userDev.userDetailedAddress, // 公司详细地址
          receiveAddress: { userProvinceId, userProvinceName, userCityId, userCityName, userAreaId, userAreaName },
          userName: userDev.userName, // 用户名
          userEmail: userDev.userEmail, // 用户邮箱
          userPhone: userDev.userPhone, // 用户手机号
          corporationProvinceId: corporationProvinceId, //户籍地址省份id
          corporationProvinceName: corporationProvinceName, //户籍地址省份
          corporationCityId: corporationCityId, //户籍地址城市id
          corporationCityName: corporationCityName, //户籍地址城市
          corporationAreaId: corporationAreaId, //户籍地址区域id
          corporationAreaName:corporationAreaName, //户籍地址区域
          corporationArea: { corporationProvinceId, corporationProvinceName, corporationCityId, corporationCityName, corporationAreaId, corporationAreaName },
          corporationDetailedAddress: userCompany.corporationDetailedAddress,
          businessLicensePath: userCompany.businessLicensePath,
          socialCreditCode: userCompany.socialCreditCode,
          corporationName: userCompany.corporationName
        }
        this.receiverAddressData.defaultData = {
          userProvinceId,
          userProvinceName,
          userCityId,
          userCityName,
          userAreaId,
          userAreaName,
        }
        this.receiverAddressData2.defaultData = {
          corporationProvinceId,
          corporationProvinceName,
          corporationCityId,
          corporationCityName,
          corporationAreaId,
          corporationAreaName,
        }
        this.cardList = userCompany.corporationPhotoPath ? userCompany.corporationPhotoPath.split(',') : []
        if (this.controlForm.businessLicensePath) {
          this.getImgUrl(this.controlForm.businessLicensePath, 'businessLicenseImageUrl')
        }
        if (this.cardList.length === 2) {
          this.getImgUrl(this.cardList[0], 'idCardImageUrl')
          this.getImgUrl(this.cardList[1], 'idCardBackImageUrl')
        }
      }
    },
    /**
     * @description 鼠标事件
     */
    mouseoverBusiness() {
      clearTimeout(this.timer)
      this.isShow = true
    },
    validateCardPath(rule, value, callback) {
      //  idCardImageUrl:"",//身份证正面照片
      //idCardBackImageUrl:"",//身份证反面照片
      if (this.isSave) {
        if (this.idCardImageUrl === '') {
          callback(new Error('请上传身份证正面照片'))
        } else if (this.idCardBackImageUrl === '') {
          callback(new Error('请上传身份证反面照片'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    receiveAddress(rule, value, callback) {
      if (this.controlForm.receiveAddress === '') {
        callback(new Error('请选择输入地址'));
        return;
      } 
      const { userProvinceName, userCityName, userAreaName } = this.controlForm.receiveAddress
      if(userProvinceName == "" || userCityName == "" || userAreaName == ""){
        callback(new Error('请选择输入地址'));
      } else {
        callback()
      }
    },
    // 移出
    mouseleaveBusiness() {
      this.timer = setTimeout(() => {
        this.isShow = false
      }, 100)
    },
    mouseoverId() {
      clearTimeout(this.timer2)
      this.isShow2 = true
    },
    mouseleaveId() {
      this.timer2 = setTimeout(() => {
        this.isShow2 = false;
      }, 100)
    }
  }
}
</script>
<style lang="scss" scoped>
.main-right {
  flex: 1;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  .main-right-header {
    margin-left: 30px;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    color: #2b2b2b;
    padding-bottom: 18px;
    box-sizing: border-box;
    display: flex;
  }
  .bd_y {
      height: 1px;
      background: #D9D9D9;
      margin-bottom: 22px;
    }
  .content-item {
    position: relative;
    padding: 0 30px;
    .item-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 20px 0;
    }
    h3 {
      font-size: 22px;
      color: #2b2d42;
      line-height: 22px;
      margin-bottom: 20px;
      .iconfont {
        color: $theme-color;
        font-size: 24px;
        margin-right: 16px;
        font-weight: normal;
      }
    }
    :first-child h3 {
      margin-bottom: 0px;
    }
    .audit-status {
      font-size: 14px;
      text-align: right;
      .iconfont {
        margin-right: 6px;
        font-size: 14px;
      }
      .iconshenhezhuangtai_weishenqingshibai {
        color: #E60012;
      }
      .iconshenhezhuangtai_shenhezhong {
        color: rgb(45, 124, 255);
      }
      .iconshenhezhuangtai_tongguo {
        color: rgb(34, 206, 136);
      }
      span{
        color: #E60012;
      }
    }
    &.second {
      margin-top: 50px;
    }
    .sandbox-title {
      color: #2b2d42;
    }
    .avatar-uploader {
      width: 200px;
      height: 113px;
      border: 1px dashed #c4c8cc;
      border-radius: 4px;
      position: relative;
      box-sizing: border-box;
      text-align: center;
      line-height: 100px;
      .avatar {
        width: 198px;
        height: 111px;
      }
    }
    .upload {
      width: 200px;
      height: 113px;
      position: relative;
      box-sizing: border-box;
      display: inline-block;
      .text {
        position: absolute;
        top: 63px;
        left: 97px;
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #a1a3a6;
        line-height: 17px;
        transform: translate(-50%, -50%);
      }
    }
    .upload-dec {
      height: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #c4c8cc;
      line-height: 16px;
      .iconicotishi {
        font-size: 12px;
        color: #2d7cff;
        cursor: pointer;
      }
    }
    // 商业执照示例弹窗
    .address {
      position: relative;
      .example-business {
        position: absolute;
        top: 0;
        left: 260px;
        width: 345px;
        height: 250px;
        background: #ffffff;
        border: 1px solid #dcdee1;
        box-shadow: 0px 0px 10px 0px rgba(209,213,223,0.5); 
        box-sizing: border-box;
        padding: 20px;
        z-index: 99;
        .img-box {
          width: 100px;
          height: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .explain {
          width: 299px;
          height: 120px;
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #9499a3;
          line-height: 20px;
          margin-top: 10px;
        }
        &::after {
          content: '';
            width: 8px;
            height: 8px;
            transform: rotate(-135deg);
            border-width:1px;
            border-style: solid;
            border-color: #dcdee1 #dcdee1 #fff #fff;
            position: absolute;
            top: 129px;
            left: -5px;
            z-index: 99;
            background: #fff;
        }
      }
      .example-id {
        position: absolute;
        top: -50px;
        left: 260px;
        width: 345px;
        height: 212px;
        background: #ffffff;
        border: 1px solid #dcdee1;
        box-shadow: 0px 0px 10px 0px rgba(209,213,223,0.5);
        box-sizing: border-box;
        padding: 20px;
        z-index: 99;
        .img-box {
          width: 220px;
          height: 62px;
          box-sizing: border-box;
          img {
            width: 47%;
            height: 100%;
            &:first-child {
              padding-right: 10px;
            }
          }
          &::after {
            content: '';
            width: 8px;
            height: 8px;
            transform: rotate(-135deg);
            border-width:1px;
            border-style: solid;
            border-color: #dcdee1 #dcdee1 #fff #fff;
            position: absolute;
            top: 179px;
            left: -5px;
            z-index: 99;
            background: #fff;
          }
        }
        .explain {
          width: 287px;
          height: 78px;
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #9499a3;
          line-height: 20px;
          margin-top: 10px;
        }
      }
      .example-id2 {
        position: absolute;
        top: -50px;
        left: 260px;
        width: 345px;
        height: 212px;
        background: #ffffff;
        border: 1px solid #dcdee1;
        box-shadow: 0px 0px 10px 0px rgba(209,213,223,0.5);
        box-sizing: border-box;
        padding: 20px;
        z-index: 99;
        .img-box {
          width: 220px;
          height: 62px;
          box-sizing: border-box;
          img {
            width: 47%;
            height: 100%;
            &:first-child {
              padding-right: 10px;
            }
          }
          &::after {
            content: '';
            width: 8px;
            height: 8px;
            transform: rotate(-135deg);
            border-width:1px;
            border-style: solid;
            border-color: #dcdee1 #dcdee1 #fff #fff;
            position: absolute;
            top: 180px;
            left: -5px;
            z-index: 99;
            background: #fff;
          }
        }
        .explain {
          width: 287px;
          height: 78px;
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #9499a3;
          line-height: 20px;
          margin-top: 10px;
        }
      }
    }
  }
}
.save {
      width: 215px;
      height: 40px;
      background-color: $theme-color;
      border-radius: 4px;
      color: #ffffff;
      margin-left: 20px;
    }
    .captchaItem {
      .sendCode {
        width: 88px;
        height: 40px;
        background-color: $theme-color;
        color: #fff;
        margin-left: 20px;
      }
    }
    .nextStep {
      width: 450px;
      height: 40px;
      background-color: $theme-color;
      color: #fff;
      font-size: 14px;
      margin-left: 180px;
      margin-top: 8px;
    }
    .back {
      width: 215px;
      height: 40px;
      border: 1px solid #b0b3b6;
      border-radius: 4px;
      color: #61666d;
      font-weight: 400;
      margin-left: 180px;
  }
  .save {
    width: 215px;
    height: 40px;
    background-color: $theme-color;
    border-radius: 4px;
    color: #ffffff;
    margin-left: 20px;
  }
</style>
